import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { TranslationService } from './../../services/translation.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
  standalone: false,
})
export class HomePage implements OnInit, AfterViewInit {
  products: any[] = [];
  translations: any;

  @ViewChild('carousel', { static: false }) carousel!: ElementRef;
  isMobileView = false;
  currentIndex = 0;

  constructor(private translationService: TranslationService) {}

  ngOnInit() {
    this.isMobileView = window.innerWidth < 768;
    this.translationService.getTranslations().subscribe((translations) => {
      this.translations = translations;

      // Dynamically populate the products array from translations
      this.products = [
        {
          title: this.translations?.products?.reprogramaTuMente?.title,
          image: '../../../assets/products/card_1.jpeg',
          url: 'https://stan.store/BetoCrypto/p/minicurso1',
          htmlContent:  this.translations?.products?.reprogramaTuMente?.html,
        },
        {
          title: this.translations?.products?.reprogramaTusFinanzas?.title,
          image: '../../../assets/products/card_2.jpeg',
          url: 'https://stan.store/BetoCrypto/p/minicurso2',
          htmlContent:this.translations?.products?.reprogramaTusFinanzas?.html
        },
        {
          title: this.translations?.products?.monetizaTuMarca?.title,
          image: '../../../assets/products/card_3.jpeg',
          url: 'https://stan.store/BetoCrypto/p/minicurso3',
          htmlContent: this.translations?.products?.monetizaTuMarca?.html,
        },
      ];
    });
  }

  ngAfterViewInit() {
    if (this.isMobileView) {
      setTimeout(() => {
        this.carousel.nativeElement.scrollLeft = 0;
        this.attachScrollListener();
      }, 100);
    }
  }

  attachScrollListener() {
    const carouselEl = this.carousel.nativeElement;
  
    carouselEl.addEventListener('scroll', () => {
      const cardWidth = carouselEl.clientWidth;
      const scrollLeft = carouselEl.scrollLeft;
  
      const newIndex = Math.round(scrollLeft / cardWidth);
  
      if (newIndex !== this.currentIndex) {
        this.currentIndex = newIndex;
      }
    });
  }

  scrollCarousel(direction: number) {
    const carouselEl = this.carousel.nativeElement as HTMLElement;
    const cardWidth = carouselEl.clientWidth;
  
    this.currentIndex = Math.max(0, Math.min(this.currentIndex + direction, this.products.length - 1));
  
    carouselEl.scrollTo({
      left: this.currentIndex * cardWidth,
      behavior: 'smooth'
    });
  }
  
}
